import React from 'react'
import { Link } from "react-router-dom";

function Courses() {
  return (
    <div>



      <div className="album py-1">
        <div className="container">
        <div className='servicecolor'>
          <h1>Our <b>Courses</b></h1>
          </div>
        </div>
      </div>
      <div className="album py-1">
        <div className="container">
          <div className="row">
            <div className="col-md-3 mt-2">
              <div className="card" >

                <div className="card-body">
                  <h5 className="card-title">Leadership Development Booster</h5>
                  
                </div>
              </div>
            </div>

            <div className="col-md-3 mt-2">
              <div className="card" >

                <div className="card-body">
                  <h5 className="card-title">Basic Accounting</h5>
                  
                </div>
              </div>
            </div>
            <div className="col-md-3 mt-2">
              <div className="card" >

                <div className="card-body">
                  <h5 className="card-title"> Basic Sales Training</h5>
                  
                </div>
              </div>
            </div>
            <div className="col-md-3 mt-2">
              <div className="card" >

                <div className="card-body">
                  <h5 className="card-title">Retail Business</h5>
                  
                </div>
              </div>
            </div>
            <div className="col-md-3 mt-2">
              <div className="card" >

                <div className="card-body">
                  <h5 className="card-title">Miscellaneous</h5>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     
    
    </div>
  )
}

export default Courses